<template>
  <div class="content-block">
    <ProjectTypeForm
      @done="onDone"
    ></ProjectTypeForm>
  </div>
</template>

<script>
import ProjectTypeForm from 'CORE/components/project/type/form'

export default {
    name: 'ProjectTypeNew',
    components: {
        ProjectTypeForm,
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'projectTypesList' })
        },
    },
}
</script>
